export default "__VITE_ASSET__BZ3Ja7rH__"